
module.exports = [
  'M1 14 L5 10 L13 18 L27 4 L31 8 L13 26 z'
].join(' ')




/*****************
 ** WEBPACK FOOTER
 ** ./~/geomicons-open/src/paths/check.js
 ** module id = 196
 ** module chunks = 0
 **/